<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="
            $route.params.id ? $t('Edit Labelorder') : $t('New Labelorder')
          "
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.from"
              label="from"
              v-validate="'required'"
              required
              data-vv-name="from"
              :error-messages="errors.collect('from')"
              type="number"
            ></v-text-field>
            <v-text-field
              v-model="formValues.to"
              label="to"
              v-validate="'required'"
              required
              data-vv-name="to"
              :error-messages="errors.collect('to')"
              type="number"
            ></v-text-field>
            <v-select
              v-model="formValues.number_range_id"
              :items="number_ranges"
              label="Numberrange"
              item-text="name"
              item-value="id"
              data-vv-name="numberrange_id"
              :error-messages="errors.collect('numberrange_id')"
            ></v-select>
            <v-select
              v-model="formValues.label_type_id"
              :items="label_types"
              label="Labeltype"
              item-text="name"
              item-value="id"
              data-vv-name="label_type_id"
              :error-messages="errors.collect('label_type_id')"
            ></v-select>
            <v-select
              v-model="formValues.company_id"
              :items="companies"
              label="Company"
              item-text="name"
              item-value="id"
              data-vv-name="company_id"
              :error-messages="errors.collect('company_id')"
            ></v-select>
            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'labelorder.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
import { fetchItems as fetchNumberranges } from "../../numberRanges/shared/services";
import { fetchItems as fetchLabeltypes } from "../../labelTypes/shared/services";
import { fetchItems as fetchCompanies } from "../../companies/shared/services";
import { fetchItems } from "../../items/shared/services";
export default {
  name: "app-labelorder-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {},
      items: [],
      permissions: [],
      loading: true,
      number_ranges: [],
      label_types: [],
      companies: []
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
      fetchItems().then(res => {
        this.items = res.data.filter(item => item.id != this.$route.params.id);
      });
    } else {
      fetchItems().then(res => {
        this.items = res.data.filter(item => item.id != this.$route.params.id);
        this.loading = false;
      });
    }
    fetchLabeltypes().then(res => {
      this.label_types = res.data;
    });
    fetchNumberranges().then(res => {
      this.number_ranges = res.data;
    });
    fetchCompanies({ page: 1, itemsPerPage: "-1" }).then(res => {
      this.companies = res.data;
    });
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "labelorder.index" });
      }
    },
    removeItem(item) {
      this.formValues.items = this.formValues.items.filter(
        _item => _item != item.id
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
